export default __webpack_public_path__ + "static/bnr_shoplist-81ecfdc3911c717af017578fea66e6ce.avif";